import React, { useState, useEffect } from 'react'
import { useTimer } from '../../../hooks/useTimer'
import { PauseIndicator } from './styles'

/**
 * Mini timer que mostra tempo acumulado de pausa
 * - Ao pausar: inicia contagem
 * - Ao retomar: para mas mantém valor
 * - Ao pausar novamente: continua somando (acumulativo)
 * Aparece quando está pausado
 */
const PauseTimer: React.FC = () => {
  const { status, pauseElapsed } = useTimer()
  const [displayTime, setDisplayTime] = useState(0)

  // Sincroniza com pauseElapsed quando muda
  useEffect(() => {
    setDisplayTime(pauseElapsed)
  }, [pauseElapsed])

  // Atualiza display a cada segundo apenas quando pausado
  useEffect(() => {
    if (status === 'paused') {
      const interval = setInterval(() => {
        setDisplayTime((prev) => prev + 1)
      }, 1000)

      return () => clearInterval(interval)
    }
  }, [status])

  // Formata tempo em MM:SS
  const formatPauseTime = (seconds: number): string => {
    const minutes = Math.floor(seconds / 60)
    const secs = seconds % 60

    if (minutes > 60) {
      const hours = Math.floor(minutes / 60)
      const remainingMinutes = minutes % 60
      return `${hours}h ${remainingMinutes.toString().padStart(2, '0')}min`
    } else {
      return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
    }
  }

  return (
    <PauseIndicator visibility={status === 'paused'}>
      Pausado há: {formatPauseTime(displayTime)}
    </PauseIndicator>
  )
}

export default PauseTimer
